import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Message } from '../models/common/message.model';
import { PaginationOptions } from '../models/common/pagination-options.model';
import { Driver } from '../models/drivers/driver.model';
import { PaginatedVehicle } from '../models/vehicles/paginated-vehicles.model';
import { Vehicle } from '../models/vehicles/vehicle.model';

@Injectable({ providedIn: 'root' })
export class VehiclesService {
    private readonly baseUrl = environment.apiUrl;
    private readonly vehiclesUrl = `${this.baseUrl}corporate/`;

    readonly listVehicles = signal<Vehicle[] | null>(null);
    readonly totalVehicles = signal<number | null>(null);

    readonly currentPage = signal<number | null>(null);
    readonly pageSize = signal<number | null>(null);
    readonly totalPages = signal<number | null>(null);

    constructor(private http: HttpClient) { }

    // private getListVehicles(): Observable<Vehicle[]> {
    //     return this.http.get<Vehicle[]>(`${this.vehiclesUrl}vehicles`, { withCredentials: true });
    // }

    private getVehiclesPaginated(options: PaginationOptions): Observable<PaginatedVehicle> {
        let params = new HttpParams()
            .set('page', options.page)
            .set('size', options.size);

        if (options.search) params = params.set('search', options.search);
        if (options.sortBy) params = params.set('sortBy', options.sortBy);
        if (options.sortDir) params = params.set('sortDir', options.sortDir);

        if (options.filters) {
            Object.entries(options.filters).forEach(([key, value]) => {
                params = params.set(key, value);
            });
        }

        return this.http.get<PaginatedVehicle>(
            `${this.vehiclesUrl}vehicles/search`,
            { params, withCredentials: true }
        );
    }

    addVehicle(vehicle: Vehicle, _corporateId?: string): Observable<Vehicle> {
        return this.http.post<Vehicle>(`${this.vehiclesUrl}vehicles`, vehicle, { withCredentials: true });
    }

    assignDriverToVehicle(vehicleId: string, driverId: string): Observable<{ driver: Driver, vehicle: Vehicle }> {
        return this.http.patch<{ driver: Driver, vehicle: Vehicle }>(`${this.vehiclesUrl}vehicles/${vehicleId}/assign-driver`, { driverId }, { withCredentials: true });
    }

    deleteVehicle(vehicleId: string): Observable<Message> {
        return this.http.patch<Message>(`${this.vehiclesUrl}vehicles/${vehicleId}/remove`, null, { withCredentials: true });
    }

    updateVehicle(vehicle: Vehicle): Observable<Vehicle> {
        return this.http.patch<Vehicle>(`${this.vehiclesUrl}vehicles/${vehicle.id}`, vehicle, { withCredentials: true });
    }

    getListVehiclesAssigned(): Observable<Vehicle[]> {
        return this.http.get<Vehicle[]>(`${this.vehiclesUrl}vehicles/assigned-list`, { withCredentials: true });
    }

    // loadListVehicles(): Observable<Vehicle[]> {
    //     return this.getListVehicles().pipe(
    //         tap(data => this.listVehicles.set(data)),
    //         catchError(error => {
    //             console.error('Error loading vehicles:', error);
    //             this.listVehicles.set([]);
    //             return of([]);
    //         })
    //     );
    // }

    loadVehiclesPaginated(options: PaginationOptions): Observable<PaginatedVehicle> {
        return this.getVehiclesPaginated(options).pipe(
            tap(data => {
                this.listVehicles.set(data.vehicles);
                this.totalVehicles.set(data.totalElements);
                this.currentPage.set(data.currentPage);
                this.pageSize.set(data.pageSize);
                this.totalPages.set(data.totalPages);
            }),
            catchError(error => {
                console.error('Error loading paginated vehicles:', error);
                this.listVehicles.set([]);
                return of({
                    vehicles: [],
                    totalElements: 0,
                    totalPages: 0,
                    currentPage: options.page,
                    pageSize: options.size
                });
            })
        );
    }

}